<template>
  <div class="cancel-wait-page">
    <main class="form-content">
      <div class="form-row">
        <span class="form-label">做钟类型：</span>
        <div class="field-box readonly-field">{{ clockTypeLabel }}</div>
      </div>
      <div class="form-row">
        <span class="form-label">技师号：</span>
        <div class="field-box readonly-field">{{ waitClockData.technicianCode }}</div>
      </div>
      <div class="form-row">
        <span class="form-label">项目名称：</span>
        <div class="field-box readonly-field">{{ waitClockData.projectName }}</div>
      </div>
      <div class="form-row">
        <span class="form-label">手牌号：</span>
        <div class="field-box readonly-field">{{ waitClockData.handCode }}</div>
      </div>
      <div class="form-row">
        <span class="form-label">房间号：</span>
        <div class="field-box readonly-field">{{ waitClockData.roomName }}</div>
      </div>
      <div class="form-row">
        <span class="form-label">做钟数量：</span>
        <div class="field-box readonly-field">{{ waitClockData.clockCount }}</div>
      </div>
    </main>

    <footer class="page-footer">
      <button type="button" class="footer-button cancel-button" @click="handleCancel">
        取消
      </button>
      <button type="button" class="footer-button save-button" @click="handleConfirm">
        确认退钟
      </button>
    </footer>
  </div>
</template>

<script>
export default {
  name: "JiShiCancelWait",
  data() {
    return {
      waitClockData: {
        id: "",
        clockType: "queue",
        technicianCode: "007",
        projectId: "6001",
        projectName: "精油按摩",
        handCode: "6002",
        roomId: "00005",
        roomName: "00005",
        clockCount: 1,
      },
    };
  },
  computed: {
    /**
     * 将接口或路由传入的钟型值转换为页面需要的中文名称。
     * 同时兼容英文状态键和已经是中文的接口值；遇到未配置的新值时原样展示，
     * 防止只读字段出现空白。
     *
     * @returns {string} 当前待钟记录的钟型名称。
     */
    clockTypeLabel() {
      const clockTypeMap = {
        queue: "排钟",
        point: "点钟",
        select: "选钟",
        call: "Call钟",
      };
      return (
        clockTypeMap[this.waitClockData.clockType] ||
        this.waitClockData.clockType ||
        "-"
      );
    },
  },
  created() {
    this.initializeWaitClockData();
  },
  methods: {
    /**
     * 使用路由查询参数初始化当前待钟记录。
     * 仅覆盖路由中真实存在且非空的字段，未传字段保留页面演示值；做钟数量转换
     * 为 Number，避免后续提交时把数字错误地作为字符串发送给接口。
     */
    initializeWaitClockData() {
      const query = this.$route && this.$route.query ? this.$route.query : {};
      Object.keys(this.waitClockData).forEach((key) => {
        if (query[key] !== undefined && query[key] !== "") {
          this.waitClockData[key] =
            key === "clockCount" ? Number(query[key]) : query[key];
        }
      });
    },
    /**
     * 放弃取消待钟操作并返回上一页。
     * 直接访问当前路由且不存在浏览历史时不执行跳转，避免返回空白页面。
     */
    handleCancel() {
      if (window.history.length > 1) {
        this.$router.back();
      }
    },
    /**
     * 确认取消当前待钟记录。
     * 页面通过 cancel-wait 事件输出完整只读记录，供父级或接口层执行实际取消；
     * 当前方法不直接修改展示数据，避免接口失败时页面状态提前改变。
     */
    handleConfirm() {
      this.$emit("cancel-wait", { ...this.waitClockData });
      this.$toast.success("操作成功");
    },
  },
};
</script>

<style scoped lang="scss">
.cancel-wait-page {
  min-height: 100vh;
  padding-bottom: calc(118px + env(safe-area-inset-bottom));
  box-sizing: border-box;
  color: #292b2e;
  background: #fffdfa;
}

.form-content {
  padding: 34px 34px 0 28px;
}

.form-row {
  display: flex;
  min-height: 60px;
  align-items: center;
  margin-bottom: 24px;
}

.form-label {
  width: 145px;
  flex: 0 0 145px;
  font-size: 27px;
  font-weight: 500;
  text-align: right;
}

.field-box {
  display: flex;
  height: 60px;
  min-width: 0;
  margin-left: 20px;
  padding: 0 24px;
  flex: 1;
  align-items: center;
  border: 1px solid #ddd8cc;
  border-radius: 14px;
  box-sizing: border-box;
  color: #a4894f;
  background: #fff;
  box-shadow: 0 1px 4px rgba(117, 101, 70, 0.06);
  font-size: 25px;
}

.readonly-field {
  color: #887c68;
  background: #f8f5ef;
  user-select: none;
}

.page-footer {
  position: fixed;
  z-index: 10;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  height: calc(106px + env(safe-area-inset-bottom));
  padding: 12px 30px env(safe-area-inset-bottom);
  align-items: flex-start;
  justify-content: space-between;
  border-top: 1px solid #eee5d7;
  box-sizing: border-box;
  background: #fffdfa;
}

.footer-button {
  width: 320px;
  height: 78px;
  border-radius: 40px;
  font-size: 31px;
  font-weight: 500;
}

.cancel-button {
  border: 1px solid #ded7ca;
  color: #b49a64;
  background: #faf7f1;
}

.save-button {
  border: 0;
  color: #fff;
  background: linear-gradient(90deg, #d0ad68, #f0c875);
}
</style>
